import React from 'react';
import { Box, Typography } from '@mui/material';
import SearchOffIcon from '@mui/icons-material/SearchOff';

const CustomNoResultsOverlay = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        minHeight: 200,
        padding: 3,
        textAlign: 'center'
      }}
    >
      <SearchOffIcon 
        sx={{ 
          fontSize: 48, 
          color: '#9e9e9e', 
          marginBottom: 2 
        }} 
      />
      <Typography 
        variant="h6" 
        sx={{ 
          color: '#666', 
          fontWeight: 500,
          marginBottom: 1
        }}
      >
        No data found
      </Typography>
      <Typography 
        variant="body2" 
        sx={{ 
          color: '#999',
          fontSize: '0.875rem'
        }}
      >
        Try adjusting your search or filters
      </Typography>
    </Box>
  );
};

export default CustomNoResultsOverlay;